import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';
import classes from './LandingPageHeroSection.module.css';

const LandingPageHeroSection = () => {
  return (
    <div className={classes.container}>
      
      <div className={classes.heroHeader}>
        <h4>
          <span className={classes.thinText}>Connecting </span>
          <span>Young People</span>
          <br />
          <span className={classes.thinText}>to Life Changing</span>
          <br />
          <span>Experiences.</span>
        </h4>
        {/* <h4>
          We are <div>
            Expanding
            <svg className={classes.svgg}
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 126 9"
              fill="none"
            >
              <path
                d="M1.34009 7.94615C29.8501 7.94615 58.1635 2.32561 86.79 2.11512C98.6623 2.02783 110.426 1.95706 122.28 2.11512C125.491 2.15794 125.349 1.52784 122.136 1.46722C116.433 1.3596 111.19 0.378442 105.363 0.675354C94.6043 1.22357 83.8105 0.831205 73.0402 1.32324C51.0768 2.32664 29.0912 1.95116 7.17113 2.76301"
                stroke="#037EF3"
                stroke-linecap="round"
              />
            </svg>
            </div>
        </h4>
        <p>AIESEC in Nigeria is now recruiting in <span>Ekiti</span>, <span>Zaria</span> and <span>Kano</span>. Don’t miss your chance to sign up, grow, and lead with students just like you.</p>
        <Link className={classes.link} to="/membership">
          Sign Up Now
        </Link>
        <img className={classes.img1} src={map} alt="Map showing locations where AIESEC in Nigeria is expanding to" />
        <div className={classes.p2}>
          <p><div className={classes.circle}></div>Recruitment for our other communities will open later this year</p>
        </div> */}
      </div>
      
      <div className={classes.inputSection}>
        {/* <div>
          <input
            type="text"
            placeholder="Search for an experience. E.g. Marketing, design, HR..."
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M18.677 19.6069L12.962 13.8909C10.4197 15.6984 6.91643 15.2562 4.90287 12.8738C2.8893 10.4914 3.03715 6.96349 5.243 4.7579C7.44826 2.55134 10.9765 2.40285 13.3594 4.41631C15.7422 6.42977 16.1846 9.93334 14.377 12.4759L20.092 18.1919L18.678 19.6059L18.677 19.6069ZM9.485 4.99988C7.5887 4.99946 5.95269 6.33057 5.56747 8.18733C5.18225 10.0441 6.15371 11.9162 7.89367 12.6701C9.63364 13.4241 11.6639 12.8527 12.7552 11.3019C13.8466 9.75117 13.6991 7.64721 12.402 6.2639L13.007 6.8639L12.325 6.1839L12.313 6.1719C11.5648 5.41907 10.5464 4.99702 9.485 4.99988Z"
              fill="#037EF3"
            />
          </svg>
        </div> */}
        <div></div>
      </div>{' '}
      {/* <Modal
        title=""
        visible={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        width={""}
        className='lg:w-1/2 w-[90%]'
        footer={[
          <Button className="rounded-[1.5rem] italic h-[40px] px-6 py-2" key="cancel" onClick={handleCancel}>
            Cancel
          </Button>,
          <Button className="bg-main rounded-[1.5rem] italic h-[40px] px-6 py-2 text-white font-bold" key="link" type="primary">
            <Link to="/ysf" onClick={() => setIsModalVisible(false)}>
              Learn More
            </Link>
          </Button>
        ]}
      >
        <div className="hover:transform-none my-4 w-full h-[full]">
          <img
            className="w-[full] h-[full] object-contain"
            src='https://res.cloudinary.com/skycoder/image/upload/v1716277382/Frame73_tbz12k.png'
            alt='Hero banner'
          />
        </div>
      </Modal> */}
      <div className={classes.videoContainer}>
        <VideoPlayer
          height="335px"
          url="https://res.cloudinary.com/dmpdhnjqs/video/upload/v1697635153/TikTok_Video_b6ioek.mp4"
          // url="https://drive.google.com/file/d/1BT9FuSCMe88MimWIK_zIN_UM9nxTSFhB/view?pli=1"
        />
      </div>
    </div>
  );
};

export default LandingPageHeroSection;
